import { useQuery } from "@tanstack/react-query";
import { Fragment, useEffect, useState } from "react";
import { Col, Form, Modal } from "react-bootstrap";
import { getRequestByAuth } from "../../../function/helper";
import PaginateCard from "../../PaginateCard";
import SelectBankAccount from "../../../pages/account/components/wallet/components/SelectBankAccount";
import Laoding from "../../Loading";

function SelectBankAccountGrid({ onSubmit }) {
  const [showModal, setShowModal] = useState(false);

  const [page, setPage] = useState(1);
  const [key, setKey] = useState();

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["bank-accounts-in-order"],
    queryFn: () =>
      getRequestByAuth(
        `/bank-account/v1/list?items=4&page=${page}${
          key ? "&page=1&search=" + key : ""
        }`
      ).then(res => {
        if (res && res.status === 200) {
          return res.data;
        }

        return { count: 0, items: [] };
      }),

    placeholderData: { count: 0, items: [] },
    retry: 0,
    refetchOnMount: true,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!isFetching) {
      refetch();
    }
  }, [page]);

  useEffect(() => {
    if (key?.length > 2 || key?.length === 0) {
      const timeOut = setTimeout(refetch, 1000);
      return () => clearTimeout(timeOut);
    }
  }, [key]);

  return (
    <Fragment>
      <button
        className="btn btn-secondary text-center mb-4"
        style={{ width: 280 }}
        onClick={() => setShowModal(true)}
      >
        انتخاب از حساب های بانکی ثبت شده
      </button>

      <Modal
        show={showModal}
        centered
        className="modal-bootstrap modal-bootstrap-backdrop"
        style={{ marginLeft: -3 }}
        size="lg"
      >
        <Modal.Header>
          <h5>انتخاب حساب بانکی</h5>
        </Modal.Header>
        <Modal.Body>
          <Col xs={12} sm={6} lg={4}>
            <Form.Control
              placeholder="جستجو بر اساس نام"
              value={key}
              onChange={e => setKey(e.target.value)}
            />
          </Col>

          {isFetching && <Laoding />}
          {!isFetching && (
            <Fragment>
              <section>
                {data.items.map(item => (
                  <SelectBankAccount
                    item={item}
                    key={item.id}
                    isSelected={false}
                    onSelect={() => {
                      onSubmit(item);
                      setShowModal(false);
                    }}
                    onDelete={refetch}
                  />
                ))}
              </section>

              <div className="mt-3">
                <PaginateCard
                  count={data.count}
                  numberItems={4}
                  numberPage={page}
                  onIndexChoose={number => setPage(number)}
                />
              </div>
            </Fragment>
          )}
        </Modal.Body>
        <Modal.Footer>
          <button
            className="buttonUi btn-cancel-style text-center"
            onClick={() => setShowModal(false)}
          >
            خروج
          </button>
        </Modal.Footer>
      </Modal>
    </Fragment>
  );
}

export default SelectBankAccountGrid;
